import { Alert, Button } from "antd";
import { Link } from "react-router-dom";
import useAuthStore from "stores/AuthStore/AuthStore";

const CONFIG = {
  VERIFIED: {
    type: "success",
    message: "Application Approved",
    description:
      "Your account has been verified. You can now log in to your dashboard.",
  },
  PENDING: {
    type: "info",
    message: "Application Under Review",
    description:
      "We've received your application and are reviewing it. This usually takes 1–2 business days. We'll notify you once a decision has been made.",
  },
  REJECTED: {
    type: "error",
    message: "Application Rejected",
  },
};

function ApplicationStatusBanner({ status, reason }) {
  const cfg = CONFIG[status] ?? CONFIG.PENDING;
  const { token } = useAuthStore();

  return (
    <Alert
      type={cfg.type}
      showIcon
      message={cfg.message}
      description={
        status === "REJECTED"
          ? reason ||
            "Your application was not approved. Please contact support for more information."
          : cfg.description
      }
      action={
        status === "VERIFIED" &&
        !token && (
          <Button type="primary" size="small">
            <Link to="/login">Go to Dashboard</Link>
          </Button>
        )
      }
    />
  );
}

export default ApplicationStatusBanner;
